(function () {
  'use strict';

  function getQuickViewButtons(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const buttons = Array.from(scope.querySelectorAll('[data-product-card-quick-view]'));
    if (scope.matches && scope.matches('[data-product-card-quick-view]')) buttons.unshift(scope);
    return buttons;
  }

  const quickViewButtonStyleProperties = [
    '--product-card-quick-view-button-radius',
    '--product-card-quick-view-button-bg',
    '--product-card-quick-view-button-border',
    '--product-card-quick-view-button-fg'
  ];

  function syncQuickViewButtonStyles(modal) {
    quickViewButtonStyleProperties.forEach((property) => {
      const value = modal ? modal.style.getPropertyValue(property).trim() : '';
      if (value) document.documentElement.style.setProperty(property, value);
      else document.documentElement.style.removeProperty(property);
    });
  }

  function syncQuickViewButtons(root) {
    const modal = document.querySelector('[data-quick-view-modal]');
    const hasQuickView = Boolean(modal);
    syncQuickViewButtonStyles(modal);

    getQuickViewButtons(root).forEach((button) => {
      button.hidden = !hasQuickView;
      button.setAttribute('aria-hidden', hasQuickView ? 'false' : 'true');
      if (!hasQuickView) {
        button.dataset.loading = 'false';
      }
    });
  }

  function initProductCardSwatches() {
    if (window.AxiomProductCardSwatchesBound) return;
    window.AxiomProductCardSwatchesBound = true;

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-product-card-swatch]');
      if (!swatch) return;

      const card = swatch.closest('[data-product-card]');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      card.querySelectorAll('[data-product-card-swatch]').forEach((button) => {
        const active = button === swatch;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const variantUrl = swatch.dataset.variantUrl;
      if (variantUrl) {
        card.querySelectorAll('[data-product-card-link]').forEach((link) => {
          link.setAttribute('href', variantUrl);
          if (link.matches('[data-mobile-quick-view-trigger]')) {
            link.dataset.productUrl = variantUrl;
          }
        });
      }

      const quickViewTrigger = card.querySelector('[data-product-card-quick-view]');
      if (quickViewTrigger && swatch.dataset.productUrl) {
        quickViewTrigger.dataset.productUrl = swatch.dataset.productUrl;
      }

      const image = card.querySelector('.product-card-link img:not(.product-card-image__hover)');
      if (image && swatch.dataset.imageSrc) {
        image.src = swatch.dataset.imageSrc;
        if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
      }

      const imageWrap = card.querySelector('.product-card-image');
      if (imageWrap && swatch.dataset.imageSrc) {
        imageWrap.classList.add('product-card-image--variant-selected');
      }

      const hoverImage = card.querySelector('.product-card-image__hover');
      if (hoverImage && swatch.dataset.imageSrc) {
        hoverImage.src = swatch.dataset.imageSrc;
        if (swatch.dataset.imageSrcset) hoverImage.srcset = swatch.dataset.imageSrcset;
      }

      const price = card.querySelector('[data-product-card-price]');
      if (price && swatch.dataset.priceHtml) {
        price.innerHTML = swatch.dataset.priceHtml;
      }

      if (window.AxiomProductBadges) {
        window.AxiomProductBadges.update(card, {
          productId: card.dataset.productId,
          available: swatch.dataset.variantAvailable === 'true',
          price: Number(swatch.dataset.variantPrice || 0),
          compareAtPrice: Number(swatch.dataset.variantCompareAtPrice || 0),
          purchaseOptionLabel: swatch.dataset.variantPurchaseOptionLabel || '',
        });
      }
    });
  }

  function init(root) {
    initProductCardSwatches();
    syncQuickViewButtons(root);
  }

  window.AxiomProductCard = window.AxiomProductCard || {};
  window.AxiomProductCard.initialize = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-quick-view-modal]')) {
      syncQuickViewButtonStyles(null);
      return;
    }
    syncQuickViewButtons(document);
  });
  document.addEventListener('axiom:section-rendered', function (event) {
    init(event.detail && event.detail.container ? event.detail.container : event.target);
  });
})();
